import { useCallback, useMemo } from "react";
import { userStore } from "../gStore/user.store";
import { Game } from "../interfaces/game.interface";
import { gameService } from "../services/game.service";
import { StarIcon } from "./atoms/Icons";

type Props = {
  game: Game | undefined;
  onGameUpdate: (updatedGame: Game) => void;
};

export const RatingStars = ({ game, onGameUpdate }: Props) => {
  const handleRatingClick = useCallback(
    (rating: number) => {
      if (!game) return;

      gameService
        .rateGame(userStore.data.user.id, game.id, rating)
        .then(() => {
          // Update the game's rating for the parent's state
          const updatedGame = { ...game, rating };
          onGameUpdate(updatedGame);
        })
        .catch((err) => {
          console.error("Failed to rate game:", err);
        });
    },
    [game, onGameUpdate]
  );

  const resolvedRating = useMemo(() => {
    return game?.rating ?? 0;
  }, [game]);

  return (
    <div className="flex justify-center md:justify-start gap-1">
      {[1, 2, 3, 4, 5].map((rating) => (
        <StarIcon
          width={48}
          height={48}
          color={rating <= resolvedRating ? "#F2C309" : "#FFF"}
          className="cursor-pointer"
          key={rating}
          onClick={() => handleRatingClick(rating)}
        />
      ))}
    </div>
  );
};
